var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import Modal from '../../../core/components/Modal';
import UserSelector from '../../../social/components/UserSelector';
import { ErrorMessage, Form, FormBlockBody, FormBlockContainer, FormBody, MembersField, SubmitButton, Footer, } from '../../../social/components/CommunityForm/styles';
import { FormContainer } from './styles';
const FormBlock = ({ children }) => (React.createElement(FormBlockContainer, null,
    React.createElement(FormBlockBody, null, children)));
export const AddMemberModal = ({ className, closeConfirm, onSubmit, usersToOmit = [] }) => {
    const { formatMessage } = useIntl();
    const { formState: { errors }, control, setError, handleSubmit, } = useForm({
        defaultValues: {
            members: [],
        },
    });
    const validateNameAndSubmit = (data) => __awaiter(void 0, void 0, void 0, function* () {
        if (data.members.length === 0) {
            setError('members', {
                message: formatMessage({ id: 'AddMemberModal.membersValidationError' }),
            });
            return;
        }
        onSubmit(data);
    });
    return (React.createElement(Modal, { isOpen: true, "data-qa-anchor": "add-member-modal", title: formatMessage({ id: 'AddMemberModal.addMembers' }), onCancel: closeConfirm },
        React.createElement(FormContainer, null,
            React.createElement(Form, { className: className, onSubmit: handleSubmit(validateNameAndSubmit) },
                React.createElement(FormBody, null,
                    React.createElement(FormBlock, null,
                        React.createElement(MembersField, { error: errors.members },
                            React.createElement(Controller, { name: "members", render: ({ field }) => (React.createElement(UserSelector, Object.assign({}, field, { usersToOmit: usersToOmit, "data-qa-anchor": "add-member-modal" }))), control: control }),
                            React.createElement(ErrorMessage, { errors: errors, name: "members" })))),
                React.createElement(Footer, null,
                    React.createElement(SubmitButton, null,
                        React.createElement(FormattedMessage, { id: "add" })))))));
};
//# sourceMappingURL=index.js.map